import React from 'react';

const Footer = () => (
  <footer className="bg-dark text-light pt-5 pb-3">
    <div className="container">
      <div className="row g-4 mb-4">
        <div className="col-12 col-md-4">
          <h5 className="text-white fw-bold">EGB Systems & Solutions, Inc.</h5>
          <p style={{ fontSize: 14, color: '#94a3b8' }}>
            Transforming e-business with strategic solutions since 1999. ISO certified, GSA contract holder, INC 500 ranked.
          </p>
        </div>
        <div className="col-6 col-md-2">
          <h6 className="text-white fw-bold mb-3">Services</h6>
          {[
            { label: 'Web Services', to: '/services' },
            { label: 'Software Dev', to: '/services' },
            { label: 'SEO & Marketing', to: '/services' },
            { label: 'Back Office', to: '/services' },
            { label: 'AI Services ✨', to: '/ai-services' },
          ].map(link => (
            <a key={link.label} href={link.to} className="d-block text-secondary text-decoration-none mb-1" style={{ fontSize: 13 }}>{link.label}</a>
          ))}
        </div>
        <div className="col-6 col-md-2">
          <h6 className="text-white fw-bold mb-3">Company</h6>
          {[
            { label: 'Overview', to: '/company/overview' },
            { label: 'Why EGB', to: '/company/why-egb' },
            { label: 'Awards', to: '/company/awards' },
            { label: 'Careers', to: '/careers' },
            { label: 'Privacy Policy', to: '/privacy-policy' },
            { label: 'Sitemap', to: '/sitemap' },
          ].map(link => (
            <a key={link.label} href={link.to} className="d-block text-secondary text-decoration-none mb-1" style={{ fontSize: 13 }}>{link.label}</a>
          ))}
        </div>
        <div className="col-12 col-md-4">
          <h6 className="text-white fw-bold mb-3">Contact</h6>
          <p style={{ fontSize: 13, color: '#94a3b8' }}>🇺🇸 1010 Summer Street, Suite 102<br />Stamford, Connecticut – 06905<br />Tel: 203 653 2741</p>
          <p style={{ fontSize: 13, color: '#94a3b8' }}>🇮🇳 135/1, L-Block 17th Street<br />Anna Nagar, Chennai – 600102<br />Tel: +91 044-35510504</p>
          <p style={{ fontSize: 13, color: '#94a3b8' }}>✉️ support@egbsystems.com</p>
        </div>
      </div>
      <div className="border-top border-secondary pt-3 d-flex flex-column flex-md-row justify-content-between align-items-center" style={{ fontSize: 13 }}>
        <span className="text-secondary">© {new Date().getFullYear()} EGB Systems & Solutions, Inc. All rights reserved.</span>
        <div className="d-flex gap-3 mt-2 mt-md-0">
          {['Privacy Policy', 'Terms of Use', 'Sitemap'].map(link => (
            <a key={link} href={link === 'Privacy Policy' ? '/privacy-policy' : link === 'Sitemap' ? '/sitemap' : '#'} className="text-secondary text-decoration-none">{link}</a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
